export const MVP_DEVICE_COMBOS = [
  'Phone only',
  'Laptop only',
  'Phone + Laptop',
];

/** i18n keys for device combo labels (value stays exact match for Dify KB). */
export const MVP_DEVICE_COMBO_I18N_KEYS = {
  'Phone only': 'device_combo_phone_only',
  'Laptop only': 'device_combo_laptop_only',
  'Phone + Laptop': 'device_combo_phone_laptop',
};

export function getDeviceComboStorageKey(sessionId) {
  return `ced:prejoin:deviceCombo:${sessionId || ''}`;
}

export function getPrejoinMediaStorageKey(sessionId) {
  return `ced:prejoin:media:${sessionId || ''}`;
}

/** @returns {{ audio: boolean, video: boolean, videoDeviceId?: string } | null} */
export function loadPrejoinMediaPrefs(sessionId) {
  if (!sessionId) return null;
  try {
    const raw = sessionStorage.getItem(getPrejoinMediaStorageKey(sessionId));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== 'object') return null;
    return {
      audio: parsed.audio !== false,
      video: parsed.video !== false,
      videoDeviceId:
        typeof parsed.videoDeviceId === 'string' && parsed.videoDeviceId
          ? parsed.videoDeviceId
          : undefined,
    };
  } catch {
    return null;
  }
}

export function savePrejoinMediaPrefs(sessionId, prefs) {
  if (!sessionId || !prefs || typeof prefs !== 'object') return;
  try {
    const payload = {
      audio: prefs.audio !== false,
      video: prefs.video !== false,
    };
    if (typeof prefs.videoDeviceId === 'string' && prefs.videoDeviceId) {
      payload.videoDeviceId = prefs.videoDeviceId;
    }
    sessionStorage.setItem(getPrejoinMediaStorageKey(sessionId), JSON.stringify(payload));
  } catch {
    // ignore quota / private mode
  }
}

export function clearPrejoinMediaPrefs(sessionId) {
  if (!sessionId) return;
  try {
    sessionStorage.removeItem(getPrejoinMediaStorageKey(sessionId));
  } catch {
    // ignore
  }
}
